var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ee-textarea",
    style: (_vm.style)
  }, [(_vm.title) ? _c('span', {
    ref: "title",
    staticClass: "ee-textarea__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('textarea', {
    staticClass: "ee-textarea__input",
    style: ({
      textIndent: (_vm.indent + "px")
    }),
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.max > 0) ? _c('span', {
    staticClass: "ee-textarea__tips"
  }, [_vm._v("还可以输入"), _c('i', [_vm._v(_vm._s(_vm.maxLen))]), _vm._v("个字")]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43418a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/textarea/Textarea.vue
// module id = 563
// module chunks = 13